<app-admin-link></app-admin-link>
<h3>Task Overview</h3>
<lib-filter-chips
  (allFiltersRemoved)="removeAllFilters()"
  (filterRemoved)="removeFilter($event)"
  [filterLockFields]="lockEnableFields"
  (filterLocked)="lockFilterChip($event)"
></lib-filter-chips>
<ag-grid-angular
  [gridOptions]="gridOptions"
  class="ag-theme-cdx"
  [sideBar]="sideBar"
  [ensureDomOrder]="true"
></ag-grid-angular>
